import ReactMarkdown from "react-markdown";

const components = {
  a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" className="font-semibold text-brand underline underline-offset-4" />,
  blockquote: ({ node, ...props }) => <blockquote {...props} className="border-l-4 border-brand-green py-2 pl-6 text-xl font-bold leading-snug text-brand [&>p]:m-0" />,
  h2: ({ node, ...props }) => <h2 {...props} className="pt-4 text-2xl font-extrabold tracking-tight text-brand" />,
  h3: ({ node, ...props }) => <h3 {...props} className="pt-2 text-xl font-extrabold text-brand" />,
  ul: ({ node, ...props }) => <ul {...props} className="list-disc space-y-2 pl-6" />,
  ol: ({ node, ...props }) => <ol {...props} className="list-decimal space-y-2 pl-6" />,
  img: () => null,
};

// Raw HTML is not rendered (react-markdown default) and unsafe URLs are stripped.
export const Markdown = ({ children, className = "", testId }) => (
  <div className={className} data-testid={testId}>
    <ReactMarkdown components={components} skipHtml>{children || ""}</ReactMarkdown>
  </div>
);
